import { all, call, put, takeEvery } from "redux-saga/effects";
import * as supportRequestActions from "../slices/supportRequestSlice";
import supportRequestApis from "src/api/supportRequest";
import { common } from "src/types";
import { constants } from "src/constants/common";

function* getSupportRequestsListAdminSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.getSupportRequestsListAdminRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.getSupportRequestsListAdmin,
      payload
    );
    yield put(
      supportRequestActions.getSupportRequestsListAdminSuccess(response)
    );
  } catch (error) {
    yield put(
      supportRequestActions.getSupportRequestsListAdminError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* getSupportRequestsListTenantSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.getSupportRequestsListTenantRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.getSupportRequestsListTenant,
      payload
    );
    yield put(
      supportRequestActions.getSupportRequestsListTenantSuccess(response)
    );
  } catch (error) {
    yield put(
      supportRequestActions.getSupportRequestsListTenantError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* getSupportRequestByIdAdminSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.getSupportRequestByIdAdminRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.getSupportRequestByIdAdmin,
      payload
    );
    yield put(
      supportRequestActions.getSupportRequestByIdAdminSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.getSupportRequestByIdAdminError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* getSupportRequestByIdTenantSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.getSupportRequestByIdTenantRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.getSupportRequestByIdTenant,
      payload
    );
    yield put(
      supportRequestActions.getSupportRequestByIdTenantSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.getSupportRequestByIdTenantError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* createSupportRequestSaga({
  payload,
}: ReturnType<typeof supportRequestActions.createSupportRequestRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.createSupportRequest,
      payload
    );
    yield put(
      supportRequestActions.createSupportRequestSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.createSupportRequestError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* raiseSupportRequestSaga({
  payload,
}: ReturnType<typeof supportRequestActions.raiseSupportRequestRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.raiseSupportRequest,
      payload
    );
    yield put(
      supportRequestActions.raiseSupportRequestSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.raiseSupportRequestError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* raiseSupportRequestAdminSaga({
  payload,
}: ReturnType<typeof supportRequestActions.raiseSupportRequestAdminRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.raiseSupportRequestAdmin,
      payload
    );
    yield put(
      supportRequestActions.raiseSupportRequestAdminSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.raiseSupportRequestAdminError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* replySupportRequestAdminSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.replySupportRequestAdminRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.replySupportRequestAdmin,
      payload
    );
    yield put(
      supportRequestActions.replySupportRequestAdminSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.replySupportRequestAdminError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* replySupportRequestTenantSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.replySupportRequestTenantRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.replySupportRequestTenant,
      payload
    );
    yield put(
      supportRequestActions.replySupportRequestTenantSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.replySupportRequestTenantError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* updateSupportRequestStatusAdminSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.updateSupportRequestStatusAdminRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.updateSupportRequestStatusAdmin,
      payload
    );
    yield put(
      supportRequestActions.updateSupportRequestStatusAdminSuccess(
        response?.data
      )
    );
  } catch (error) {
    yield put(
      supportRequestActions.updateSupportRequestStatusAdminError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* supportRequestSaga() {
  yield all([
    takeEvery(
      supportRequestActions.getSupportRequestsListAdminRequest,
      getSupportRequestsListAdminSaga
    ),
    takeEvery(
      supportRequestActions.getSupportRequestsListTenantRequest,
      getSupportRequestsListTenantSaga
    ),
    takeEvery(
      supportRequestActions.getSupportRequestByIdAdminRequest,
      getSupportRequestByIdAdminSaga
    ),
    takeEvery(
      supportRequestActions.getSupportRequestByIdTenantRequest,
      getSupportRequestByIdTenantSaga
    ),
    takeEvery(
      supportRequestActions.createSupportRequestRequest,
      createSupportRequestSaga
    ),
    takeEvery(
      supportRequestActions.raiseSupportRequestRequest,
      raiseSupportRequestSaga
    ),
    takeEvery(
      supportRequestActions.raiseSupportRequestAdminRequest,
      raiseSupportRequestAdminSaga
    ),
    takeEvery(
      supportRequestActions.replySupportRequestAdminRequest,
      replySupportRequestAdminSaga
    ),
    takeEvery(
      supportRequestActions.replySupportRequestTenantRequest,
      replySupportRequestTenantSaga
    ),
    takeEvery(
      supportRequestActions.updateSupportRequestStatusAdminRequest,
      updateSupportRequestStatusAdminSaga
    ),
  ]);
}
